import { render, staticRenderFns } from "./ImportMappingsView.vue?vue&type=template&id=7a2f5887&scoped=true&"
import script from "./ImportMappingsView.vue?vue&type=script&lang=js&"
export * from "./ImportMappingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2f5887",
  null
  
)

export default component.exports